export default () => {
  return <div className="service-full">
    <iframe src="http://q.url.cn/CDJ3Xl?_type=wpa&qidian=true"/>
  </div>;
}
